module.exports = __webpack_public_path__ + "static/media/icon-check.3daf24a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-check.svg
// module id = 1245
// module chunks = 19